/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IntervalWeather,
    IntervalWeatherFromJSON,
    IntervalWeatherFromJSONTyped,
    IntervalWeatherToJSON,
} from './IntervalWeather';

/**
 * 
 * @export
 * @interface LocalityWeatherResponse
 */
export interface LocalityWeatherResponse {
    /**
     * 
     * @type {Array<IntervalWeather>}
     * @memberof LocalityWeatherResponse
     */
    intervals: Array<IntervalWeather>;
}

export function LocalityWeatherResponseFromJSON(json: any): LocalityWeatherResponse {
    return LocalityWeatherResponseFromJSONTyped(json, false);
}

export function LocalityWeatherResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocalityWeatherResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'intervals': ((json['intervals'] as Array<any>).map(IntervalWeatherFromJSON)),
    };
}

export function LocalityWeatherResponseToJSON(value?: LocalityWeatherResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'intervals': ((value.intervals as Array<any>).map(IntervalWeatherToJSON)),
    };
}

